import React from 'react';
import logo512 from '../assets/images/logo512.png';
import image2 from '../assets/images/image2.png';
import image3 from '../assets/images/image3.png';
import image4 from '../assets/images/image4.png';
import image5 from '../assets/images/image5.png';
import image6 from '../assets/images/image6.png';
import image8 from '../assets/images/image8.png';
import image9 from '../assets/images/image9.png';
import image10 from '../assets/images/image10.png';
import image11 from '../assets/images/image11.png';

const About: React.FC = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2rem' }}>
            <img 
              src={logo512} 
              alt="Đức Phát Đạt Logo" 
              style={{ 
                height: '80px', 
                width: 'auto', 
                marginRight: '20px'
              }} 
            />
            <div>
              <h1 style={{ margin: 0 }}>Về Đức Phát Đạt</h1>
              <p style={{ margin: '0.5rem 0 0 0' }}>Hơn 15 năm hoạt động trên thị trường Gỗ Việt Nam</p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'center', gap: '4rem' }}>
            <div>
              <h2>Câu chuyện của chúng tôi</h2>
              <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
                Hơn 15 năm hoạt động trên thị trường Gỗ Việt Nam, Công ty TNHH Đức Phát Đạt là một trong những chuyên gia phân phối gỗ nguyên liệu hàng đầu.
              </p>
              <p style={{ marginBottom: '1.5rem' }}>
                Tôn chỉ hoạt động của Đức Phát Đạt luôn đặt chữ "TÍN" lên hàng đầu. Vì vậy, từ khi thành lập vào năm 2009 đến nay, Đức Phát Đạt luôn là đối tác tin cậy và thường xuyên của nhiều đơn vị sản xuất, xuất khẩu hàng nội – ngoại thất.
              </p>
              <p>
                Sản phẩm mà Đức Phát Đạt nhập khẩu và cung cấp hoàn toàn là gỗ được khai thác hợp pháp, đảm bảo yếu tố bảo vệ môi trường.
              </p>
            </div>
            <div className="card">
              <h3>Thành lập</h3>
              <p style={{ fontSize: '3rem', color: 'var(--primary-color)', fontWeight: 'bold' }}>2009</p>
              <p>Năm thành lập công ty</p>
              
              <h3 style={{ marginTop: '2rem' }}>Kinh nghiệm</h3>
              <p style={{ fontSize: '3rem', color: 'var(--primary-color)', fontWeight: 'bold' }}>15+</p>
              <p>Năm kinh nghiệm trong ngành gỗ</p>
            </div>
          </div>
        </div>
      </section>

      {/* Log Images Gallery */}
      <section className="section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>Sản phẩm gỗ của chúng tôi</h2>
            <p>Hình ảnh về các loại gỗ tròn, gỗ xây dựng và hoạt động vận chuyển</p>
          </div>
          
          <div className="grid grid-3" style={{ marginBottom: '2rem' }}>
            
            <div className="card text-center">
              <img src={image2} alt="Gỗ thông Coffa" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ thông Coffa</h4>
              <p>Gỗ thông Coffa nhập khẩu chất lượng cao, màu sắc tự nhiên</p>
            </div>
            
            <div className="card text-center">
              <img src={image3} alt="Gỗ thông sấy" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ thông sấy</h4>
              <p>Gỗ thông đã qua quá trình sấy khô kỹ lưỡng, đảm bảo độ bền</p>
            </div>
          </div>

          <div className="grid grid-3" style={{ marginBottom: '2rem' }}>
            <div className="card text-center">
              <img src={image4} alt="Gỗ tròn nhập khẩu" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ tròn nhập khẩu</h4>
              <p>Đa dạng kích thước phục vụ nhu cầu khác nhau</p>
            </div>
            
            <div className="card text-center">
              <img src={image5} alt="Gỗ xây dựng" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ xây dựng</h4>
              <p>Các loại gỗ xây dựng chất lượng cao cho công trình</p>
            </div>
            
            <div className="card text-center">
              <img src={image6} alt="Gỗ nguyên liệu" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ nguyên liệu</h4>
              <p>Gỗ nguyên liệu đa dạng cho sản xuất và chế biến</p>
            </div>
          </div>

          <div className="grid grid-3" style={{ marginBottom: '2rem' }}>
            <div className="card text-center">
              <img src={image8} alt="Xe cẩu chuyên nghiệp" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Xe cẩu chuyên nghiệp</h4>
              <p>Đội ngũ lái xe 10 năm kinh nghiệm, đảm bảo an toàn</p>
            </div>
            
            <div className="card text-center">
              <img src={image9} alt="Vận chuyển thiết bị nặng" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Vận chuyển thiết bị nặng</h4>
              <p>Chuyên vận chuyển thiết bị nặng và gỗ với đội ngũ chuyên nghiệp</p>
            </div>
            
            <div className="card text-center">
              <img src={image10} alt="Vận chuyển nhà xưởng" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Vận chuyển nhà xưởng</h4>
              <p>Dịch vụ vận chuyển cho các nhà xưởng lớn</p>
            </div>
          </div>

          <div className="text-center">
            <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
              <img src={image11} alt="Cách tính khối gỗ tròn" style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Kiến thức chuyên môn</h4>
              <p>Cách tính khối gỗ tròn chính xác với công thức chuyên nghiệp</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>Giá trị cốt lõi</h2>
            <p>Những nguyên tắc hoạt động của chúng tôi</p>
          </div>
          
          <div className="grid grid-3">
            <div className="card text-center">
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🤝</div>
              <h3>Tín</h3>
              <p>Đặt chữ "TÍN" lên hàng đầu trong mọi hoạt động kinh doanh, xây dựng niềm tin với khách hàng và đối tác.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🌱</div>
              <h3>Bảo vệ môi trường</h3>
              <p>Cam kết chỉ cung cấp gỗ được khai thác hợp pháp, góp phần bảo vệ môi trường và phát triển bền vững.</p>
            </div>
            
            <div className="card text-center">
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⭐</div>
              <h3>Chất lượng</h3>
              <p>Đảm bảo chất lượng sản phẩm và dịch vụ cao nhất, đáp ứng mọi yêu cầu của khách hàng.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Đội ngũ chuyên nghiệp</h2>
            <p>Đội ngũ nhân viên giàu kinh nghiệm và tận tâm</p>
          </div>
          
          <div className="grid grid-2">
            <div className="card">
              <h3>Kinh nghiệm chuyên môn</h3>
              <p>Đội ngũ nhân viên với hơn 15 năm kinh nghiệm trong ngành gỗ, am hiểu sâu về các loại gỗ và kỹ thuật xử lý.</p>
            </div>
            
            <div className="card">
              <h3>Dịch vụ tận tâm</h3>
              <p>Luôn sẵn sàng tư vấn và hỗ trợ khách hàng 24/7, đảm bảo mọi nhu cầu được đáp ứng nhanh chóng và chính xác.</p>
            </div>
            
            <div className="card">
              <h3>Lái xe chuyên nghiệp</h3>
              <p>Đội ngũ lái xe với 10 năm kinh nghiệm trong ngành, đảm bảo an toàn và hiệu quả trong vận chuyển.</p>
            </div>
            
            <div className="card">
              <h3>Kỹ thuật viên lành nghề</h3>
              <p>Các kỹ thuật viên được đào tạo chuyên nghiệp, có khả năng cưa xẻ gỗ với độ chính xác cao.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="section bg-light">
        <div className="container text-center">
          <h2>Thông tin liên hệ</h2>
          <div className="grid grid-2" style={{ marginTop: '2rem' }}>
            <div className="card">
              <h3>Địa chỉ</h3>
              <p>Số 2 Hoàng Hữu Nam<br />
              Phường Long Bình, TP HCM</p>
              <a 
                href="https://goo.gl/maps/v3FYpZXcdGvYEdc39?g_st=az" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Xem trên Google Maps
              </a>
            </div>
            
            <div className="card">
              <h3>Liên hệ trực tiếp</h3>
              <p><strong>Hotline:</strong><br />
              0915 444 447 (anh Kiên)<br />
              0906 838 171 (cô Nhung)</p>
              <p><strong>📧 Email:</strong><br />
              ducphatdatco@gmail.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;

